import styled from 'styled-components'
import { theme } from '../../styles/_variables'

export const EachNoti = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 4px 0;
  padding: 16px;
  width: 100%;
  background: ${props => (props.read ? theme.color.offWhite : theme.color.primaryColor)};
  > P {
    color: ${props => (props.read ? theme.color.black : theme.color.offWhite)};
  }
  cursor: pointer;
  :hover {
    background: ${props => (props.read ? 'rgb(223, 223, 223, 0.5)' : theme.color.secondaryColor)};
  }
`

export default EachNoti
